export function filterFormatterAsPerModel<T>(formData: {}, model: T) {
  let filter = ""
  if (formData !== null && formData !== undefined) {
    Object.getOwnPropertyNames(model).forEach((val) => {
      Object.entries(formData).forEach((x) => {
        if (Array.isArray(x)) {
          if (x[0] === val) {
            if (x[1] === null) {
              filter += `${val} eq ${x[1]} and `
            } else {
              filter += `contains(tolower(${val}),tolower('${x[1]}')) and `
            }
          }
        }
      })
    })
  }

  if (filter.endsWith("and ")) {
    filter = filter.substring(0, filter.lastIndexOf("and "))
  }

  return encodeURIComponent(filter)
}
